import React from 'react'

import clsx from 'clsx'

import CtaButton from 'components/CtaButton'
import Form from 'components/Form'
import Icon from 'components/Icon'
import { useCompareBasket } from 'context/CompareBasketContext'
import { useEventContext } from 'context/EventContext'
import detachTask from 'helpers/detachTask'

import classes from './Compare.module.scss'

/** @type {import("./types").default} */
const Compare = ({
  listing,
  className,
  children,
  onClick,
  useBasket,
  disabled,
  engagementComponent = 'product_card-item',
  testId = 'listing-item_compare_cta',
  fullWidth = true,
  variant = 'text',
  ...props
}) => {
  const compareBasket = useCompareBasket()
  const { addEvent } = useEventContext({
    engagementComponent,
  })
  const canUseBasket = useBasket && compareBasket.isEnabled
  const isInBasket = canUseBasket ? compareBasket.isInBasket(listing) : false
  const highlyViewedEventString = listing.most_visited ? ' | highly-viewed' : ''

  const onMouseDown = event => {
    if (onClick) {
      onClick(event)
    }

    if (canUseBasket) {
      event.preventDefault()
      detachTask(compareBasket.toggleItem, listing)

      return
    }
  }

  const compareEvent = canUseBasket
    ? {
        engagementDetails: 'button_compare' + highlyViewedEventString,
        engagementDestination: isInBasket ? 'compare-basket_remove-product' : 'compare-basket_add-product',
        name: 'engagement_compare_tray',
      }
    : {
        engagementDetails: 'button_compare',
        engagementDestination: 'go-to_product_comparisons',
        name: 'engagement_cta_compare',
      }

  const isDisabled = disabled || (canUseBasket && compareBasket.isFull && !isInBasket)

  const ctaColor = isInBasket ? 'secondary' : 'primary'

  return (
    <CtaButton
      className={clsx('Compare', classes.compareButton, className)}
      data-testid={testId}
      onClick={onMouseDown}
      fullWidth={fullWidth}
      variant={variant}
      disabled={isDisabled}
      color={ctaColor}
      {...props}
      {...addEvent(compareEvent)}
    >
      {canUseBasket ? (
        <span className={classes.basket}>
          {isInBasket ? (
            <Form.Checkbox className={clsx(classes.icon, classes.checkbox)} checked noAnimation variant={ctaColor} />
          ) : (
            <Icon
              icon={['ga', 'compare']}
              size={16}
              className={clsx(classes.icon, {
                [classes.disabled]: isDisabled,
              })}
            />
          )}
          <span
            className={clsx({
              [classes.disabled]: isDisabled,
            })}
          >
            Compare
          </span>
        </span>
      ) : (
        children || 'Compare'
      )}
    </CtaButton>
  )
}

export default Compare
